<template>
  <div>
    <!-- Modal -->

    <div
      class="modal fade"
      id="depositModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="depositModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="depositModalLabel">
              <svg
                id="moneySvg"
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <title>moneybag-glyph</title>
                <path
                  d="M175.78,88.45H336.2S399.78,24.83,371,4.16,278.47,46.78,256,45.24c-22.46,1.54-86.27-61.77-115-41.08S175.78,88.45,175.78,88.45Z"
                  fill="#212121"
                />
                <path
                  d="M184.09,99a14.39,14.39,0,0,0,0,28.77H327.89a14.39,14.39,0,0,0,0-28.77Z"
                  fill="#212121"
                />
                <path
                  d="M289.8,324.62a61.11,61.11,0,0,0-13.27-8q-7.47-3.41-15.67-6.38L261,263a21.69,21.69,0,0,1,11.85,5.71q4.59,4.47,4.6,12.5v3.77a38.39,38.39,0,0,0,5.5.4,22.78,22.78,0,0,0,5.46-.67,15.26,15.26,0,0,0,4.83-2.06,11.81,11.81,0,0,0,3.48-3.56,9.66,9.66,0,0,0,1.35-5.23,14.54,14.54,0,0,0-4-10.58,27.72,27.72,0,0,0-9.71-6.23,49.63,49.63,0,0,0-12.19-2.92q-6.41-.75-11.23-.87l.15-17.15-10.58,1.23v16.33a68.15,68.15,0,0,0-15.25,3.27,40.2,40.2,0,0,0-12.65,6.87,32.13,32.13,0,0,0-8.63,11,34.77,34.77,0,0,0-3.23,15.4,32.71,32.71,0,0,0,3.35,15.27,38.13,38.13,0,0,0,8.9,11.27,57.78,57.78,0,0,0,12.79,8.27q7.22,3.47,15,6.42v49.79c-6.69-.46-11.77-2.35-15.19-5.71s-5.17-8.35-5.17-15v-3.9a39,39,0,0,0-5.62-.37,20.57,20.57,0,0,0-5.67.75,15.28,15.28,0,0,0-4.87,2.17,11.25,11.25,0,0,0-3.44,3.77,10.82,10.82,0,0,0-1.25,5.35c0,4.9,1.46,8.83,4.42,11.83a29.81,29.81,0,0,0,10.69,6.92,56.67,56.67,0,0,0,13.19,3.19,103.67,103.67,0,0,0,11.83.83h1.08l.15,16.71,9.63-2v-15.4a72.17,72.17,0,0,0,16-3.86A44,44,0,0,0,290,378.73,35.16,35.16,0,0,0,299,367a37.6,37.6,0,0,0,3.33-16.46,30.87,30.87,0,0,0-3.44-15A35.31,35.31,0,0,0,289.8,324.62ZM243,303.16a29.34,29.34,0,0,1-6.52-4.85,20.69,20.69,0,0,1-6.15-15.4A17.58,17.58,0,0,1,232,275.1a19.7,19.7,0,0,1,4.27-6,21.72,21.72,0,0,1,6.33-4.06,30.55,30.55,0,0,1,8-2.08l.15,44A69.41,69.41,0,0,1,243,303.16Zm37.71,63.13a21.23,21.23,0,0,1-4.6,6.83,24.92,24.92,0,0,1-7,4.85,31.47,31.47,0,0,1-8.56,2.77l.15-46.33c2.75,1.08,5.46,2.29,8.08,3.63a31.1,31.1,0,0,1,7,4.77,21,21,0,0,1,4.81,6.33,18.67,18.67,0,0,1,1.81,8.46A21.34,21.34,0,0,1,280.74,366.29Z"
                  fill="#212121"
                />
                <path
                  d="M336.2,138.26H175.78c-71.25,52-121.08,162.09-121.08,232C54.69,464.33,144.8,512,256,512s201.32-47.67,201.32-141.73C457.31,300.35,407.45,190.22,336.2,138.26ZM256,430.85a109,109,0,1,1,109-109A109,109,0,0,1,256,430.85Z"
                  fill="#212121"
                />
              </svg>
              شارژ کیف پول
            </h5>
          </div>
          <div class="modal-body">
            <div id="inputs">
              <!-- <label for="amount">مبلغ بر حسب تومان:</label>
            <input @keypress.enter="deposit()"  placeholder="لطفا مبلغ را به تومان وارد کنید" ref="amount"
                   type="text" :value="amount | priceinput" @input="e=>{amount = +e.target.value.replace(/\D/g, '')}"
                   id="amountInput" inputmode="numeric" /> -->
              <label for="amount">مبلغ بر حسب تومان:</label>
              <input
                @keypress.enter="deposit()"
                placeholder="لطفا مبلغ را به تومان وارد کنید"
                ref="amount"
                type="text"
                :value="priceinput(amount)"
                @input="
                  (e) => {
                    amount = +e.target.value.replace(/\D/g, '');
                  }
                "
                id="amountInput"
                inputmode="numeric"
              />
              <div class="text-right mt-4">انتخاب درگاه:</div>
              <Gateways
                class="mt-1"
                @gatewaySelected="onGatewaySelected"
                :selected-gateway="selectedGateway"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-dismiss="modal">
              بستن
            </button>
            <button
              :class="{ disabled: disabled }"
              type="button"
              class="btn  bg-color-theme"
              @click="deposit()"
            >
              افزایش
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { pay } from "@/libraries/functions";
import Gateways from "../../shared/Gateways";

export default {
  components: { Gateways },
  inject: ["mediaQueries"],
  data() {
    return {
      amount: null,
      disabled: false,
      selectedGateway: null,
    };
  },
  methods: {
    priceinput(num) {
      if (num) {
        return num
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "";
      }
    },
    onGatewaySelected(gateway) {
      this.selectedGateway = gateway;
    },
    deposit() {
      if (this.amount == null || this.amount < 1000) {
        return window
          .swal({
            title: "حداقل مبلغ باید 1000 تومان باشد",
            showConfirmButton: true,
            button: " تایید",
          })
          .then(() => {
            this.$refs.amount.focus();
          });
      } else {
        const formData = new FormData();
        formData.append("amount", this.amount);
        formData.append("payment_driver", this.selectedGateway.name);
        this.disabled = true;
        this.$axios
          .post("/customer/deposit", formData)
          .then((response) => {
            let responseData = response.data.data;
            let makeResponse = responseData.make_response;
            pay(makeResponse);
          })
          .finally(() => (this.disabled = false));
      }
    },
  },
};
</script>
<style scoped>
/* برداشتن دکمه های بالا پایین برای ورود عدد */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
#inputs {
  display: flex;
  flex-direction: column;
}
#inputs input {
  border-bottom: 1px solid #80808099;
  width: 85%;
  margin: auto;
}
.bg-color-theme {
  background-color: #121314;
  color: white;
  border-color: transparent;
}
#moneySvg {
  width: 20px;
}
</style>
